export default __webpack_public_path__ + "assets/647dad06a5811f210a0ae005909b550d.svg";